import { render, staticRenderFns } from "./DataStatistics.vue?vue&type=template&id=4d966f5a&scoped=true"
import script from "./DataStatistics.vue?vue&type=script&lang=js"
export * from "./DataStatistics.vue?vue&type=script&lang=js"
import style0 from "./DataStatistics.vue?vue&type=style&index=0&id=4d966f5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d966f5a",
  null
  
)

export default component.exports